import React, {useEffect, useState} from 'react';
import {DropdownInput} from './FileTypePicker.style';
import {generateIdentifier} from '../../utils/IdentityUtils';
import {DropdownOptionProps, DropdownSingleValueProps} from '../../models/DropdownProps';

export const FileTypePicker: React.VFC<DropdownSingleValueProps<string>> = (props) => {
    const [fileTypeInput, setFileTypeInput] = useState<string>(props.defaultValue ? props.defaultValue : '');
    const [fileTypeOptions, setFileTypeOptions] = useState<DropdownOptionProps[]>(props.dataSource);

    const setState = (selectionState: string, selectionOptions: DropdownOptionProps[], resetInput: boolean) => {
        props.onChange(selectionState);
        setFileTypeOptions(selectionOptions);
        if (resetInput) {
            setFileTypeInput('');
        }
    };

    useEffect(() => {
        setFileTypeOptions(props.dataSource);
    }, [props.dataSource]);

    useEffect(() => {
        if (props.resetState) {
            setState('', props.dataSource, true);
        }
    }, [props.resetState]);

    const handleInput = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let eventValue = e.target.value.toString();
        setFileTypeInput(eventValue);
        let selectionOptions = fileTypeOptions;
        if (props.resetInput) {
            selectionOptions = fileTypeOptions.filter(type => (type.name !== eventValue));
        }
        setState(eventValue, selectionOptions, props.resetInput);
    };

    return (
        <DropdownInput id={generateIdentifier('fileTypeId_'.concat(fileTypeInput))}
                       defaultValue={props.defaultValue ? props.defaultValue : ''}
                       name={'fileTypeName_'.concat(fileTypeInput)}
                       aria-label={'fileTypeName_'.concat(fileTypeInput) + 'File Type Filter'}
                       value={fileTypeInput}
                       options={fileTypeOptions}
                       disabled={props.disabled}
                       onChange={handleInput}/>
    );
};
